{
  "HELP_CENTER": {
    "TITLE": "Centrum nápovědy",
    "NEW_ARTICLE_PAGE": {
      "PLACEHOLDER_TITLE": "Bez názvu"
    },
    "NEW_PAGE": {
      "DESCRIPTION": "Vytvořte samoobslužné portály centra nápovědy pro své zákazníky. Pomozte jim rychle najít odpovědi bez čekání. Zefektivněte dotazy, zvyšte efektivitu agentů a pozvedněte zákaznickou podporu.",
      "CREATE_PORTAL_BUTTON": "Vytvořit portál"
    },
    "HEADER": {
      "FILTER": "Filtrovat podle",
      "SORT": "Seřadit podle",
      "LOCALE": "Jazyk",
      "SETTINGS_BUTTON": "Nastavení",
      "NEW_BUTTON": "Nový článek",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "Publikované",
        "DRAFT": "Koncept",
        "ARCHIVED": "Archivované"
      },
      "TITLES": {
        "ALL_ARTICLES": "Všechny články",
        "MINE": "Moje články",
        "DRAFT": "Koncepty článků",
        "ARCHIVED": "Archivované články"
      },
      "LOCALE_SELECT": {
        "TITLE": "Vybrat jazyk",
        "PLACEHOLDER": "Vybrat jazyk",
        "NO_RESULT": "Nenalezen žádný jazyk",
        "SEARCH_PLACEHOLDER": "Hledat jazyk"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "Všechny články",
      "PUBLISH_BUTTON": "Publikovat",
      "MOVE_TO_ARCHIVE_BUTTON": "Přesunout do archivu",
      "PREVIEW": "Náhled",
      "ADD_TRANSLATION": "Přidat překlad",
      "OPEN_SIDEBAR": "Otevřít postranní panel",
      "CLOSE_SIDEBAR": "Zavřít postranní panel",
      "SAVING": "Ukládání...",
      "SAVED": "Uloženo"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "Nahrát obrázek",
        "UPLOADING": "Nahrávání...",
        "SUCCESS": "Obrázek byl úspěšně nahrán",
        "ERROR": "Chyba při nahrávání obrázku",
        "UN_AUTHORIZED_ERROR": "Nemáte oprávnění k nahrávání obrázků",
        "ERROR_FILE_SIZE": "Velikost obrázku by měla být menší než {size}MB",
        "ERROR_FILE_FORMAT": "Formát obrázku by měl být jpg, jpeg nebo png",
        "ERROR_FILE_DIMENSIONS": "Rozměry obrázku by měly být menší než 2000 x 2000"
      },
      "ANCHOR": {
        "BUTTON": "Vložit kotvu",
        "TITLE": "Vložit kotvu",
        "SUBMIT": "Vložit",
        "PLACEHOLDER": "anchor-name"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "Nastavení článků",
      "FORM": {
        "CATEGORY": {
          "LABEL": "Kategorie",
          "TITLE": "Vyberte kategorii",
          "PLACEHOLDER": "Vyberte kategorii",
          "NO_RESULT": "Nebyla nalezena žádná kategorie",
          "SEARCH_PLACEHOLDER": "Hledat kategorii"
        },
        "AUTHOR": {
          "LABEL": "Autor",
          "TITLE": "Vyberte autora",
          "PLACEHOLDER": "Vyberte autora",
          "NO_RESULT": "Nebyli nalezeni žádní autoři",
          "SEARCH_PLACEHOLDER": "Hledat autora"
        },
        "META_TITLE": {
          "LABEL": "Meta titulek",
          "PLACEHOLDER": "Přidat meta titulek"
        },
        "META_DESCRIPTION": {
          "LABEL": "Meta popis",
          "PLACEHOLDER": "Přidejte svůj meta popis pro lepší výsledky SEO..."
        },
        "META_TAGS": {
          "LABEL": "Meta tagy",
          "PLACEHOLDER": "Přidat meta tagy oddělené čárkou..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "Archivovat článek",
        "DELETE": "Odstranit článek"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "Nekategorizováno",
      "SEARCH_RESULTS": "Výsledky vyhledávání pro {query}",
      "EMPTY_TEXT": "Hledejte články, které chcete vložit do odpovědí.",
      "SEARCH_LOADER": "Vyhledávání...",
      "INSERT_ARTICLE": "Vložit",
      "NO_RESULT": "Nebyly nalezeny žádné články",
      "COPY_LINK": "Zkopírovat odkaz na článek do schránky",
      "OPEN_LINK": "Otevřít článek v nové záložce",
      "PREVIEW_LINK": "Náhled článku"
    },
    "PORTAL": {
      "HEADER": "Portály",
      "DEFAULT": "Výchozí",
      "NEW_BUTTON": "Nový portál",
      "ACTIVE_BADGE": "aktivní",
      "CHOOSE_LOCALE_LABEL": "Vyberte jazyk",
      "LOADING_MESSAGE": "Načítání portálů...",
      "ARTICLES_LABEL": "články",
      "NO_PORTALS_MESSAGE": "Nejsou dostupné žádné portály",
      "ADD_NEW_LOCALE": "Přidat nový jazyk",
      "POPOVER": {
        "TITLE": "Portály",
        "PORTAL_SETTINGS": "Nastavení portálu",
        "SUBTITLE": "Máte více portálů a můžete mít různé jazyky pro každý portál.",
        "CANCEL_BUTTON_LABEL": "Zrušit",
        "CHOOSE_LOCALE_BUTTON": "Vybrat jazyk"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "články",
            "ADD": "Přidat jazyk",
            "VISIT": "Navštívit stránku",
            "SETTINGS": "Nastavení",
            "DELETE": "Vymazat"
          },
          "PORTAL_CONFIG": {
            "TITLE": "Konfigurace portálu",
            "ITEMS": {
              "NAME": "Název",
              "DOMAIN": "Vlastní doména",
              "SLUG": "Slug",
              "TITLE": "Název portálu",
              "THEME": "Barva motivu",
              "SUB_TEXT": "Vedlejší text portálu"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "Dostupné jazyky",
            "TABLE": {
              "NAME": "Název jazyka",
              "CODE": "Kód jazyka",
              "ARTICLE_COUNT": "Počet článků",
              "CATEGORIES": "Počet kategorií",
              "SWAP": "Zaměnit",
              "DELETE": "Vymazat",
              "DEFAULT_LOCALE": "Výchozí"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "Smazat portál",
          "MESSAGE": "Opravdu chcete smazat tento portál",
          "YES": "Ano, smazat portál",
          "NO": "Ne, zachovat portál",
          "API": {
            "DELETE_SUCCESS": "Portál byl úspěšně smazán",
            "DELETE_ERROR": "Chyba při mazání portálu"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "Upravit portál",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "Základní informace"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "Přizpůsobení portálu"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "Kategorie"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "Jazyky"
          }
        },
        "CATEGORIES": {
          "TITLE": "Kategorie v",
          "NEW_CATEGORY": "Nová kategorie",
          "TABLE": {
            "NAME": "Název",
            "DESCRIPTION": "Popis",
            "LOCALE": "Jazyk",
            "ARTICLE_COUNT": "Počet článků",
            "ACTION_BUTTON": {
              "EDIT": "Upravit kategorii",
              "DELETE": "Smazat kategorii"
            },
            "EMPTY_TEXT": "Nebyly nalezeny žádné kategorie"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "Aktualizovat základní nastavení"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "Informace o centru nápovědy",
            "BODY": "Základní informace o portálu"
          },
          "CUSTOMIZATION": {
            "TITLE": "Přizpůsobení centra nápovědy",
            "BODY": "Přizpůsobit portál"
          },
          "FINISH": {
            "TITLE": "Voilá! 🎉",
            "BODY": "Vše je připraveno!"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "Zpět",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "Vytvořit portál",
            "TITLE": "Informace o centru nápovědy",
            "CREATE_BASIC_SETTING_BUTTON": "Vytvořit základní nastavení portálu"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "Přizpůsobení portálu",
            "TITLE": "Přizpůsobení centra nápovědy",
            "UPDATE_PORTAL_BUTTON": "Aktualizovat nastavení portálu"
          },
          "FINISH_PAGE": {
            "TITLE": "Voilá!🎉 Vše je nastaveno!",
            "MESSAGE": "Nyní můžete vidět tento vytvořený portál na stránce všech portálů.",
            "FINISH": "Přejít na stránku všech portálů"
          }
        },
        "LOGO": {
          "LABEL": "Logo",
          "UPLOAD_BUTTON": "Nahrát logo",
          "HELP_TEXT": "Toto logo se zobrazí v záhlaví portálu.",
          "IMAGE_UPLOAD_SUCCESS": "Logo úspěšně nahráno",
          "IMAGE_UPLOAD_ERROR": "Logo úspěšně smazáno",
          "IMAGE_DELETE_ERROR": "Chyba při mazání loga"
        },
        "NAME": {
          "LABEL": "Název",
          "PLACEHOLDER": "Název portálu",
          "HELP_TEXT": "Název bude použit v interním veřejně přístupném portálu.",
          "ERROR": "Název je povinný"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug portálu pro URL adresy",
          "ERROR": "Slug je povinný"
        },
        "DOMAIN": {
          "LABEL": "Vlastní doména",
          "PLACEHOLDER": "Vlastní doména portálu",
          "HELP_TEXT": "Přidejte pouze pokud chcete používat vlastní doménu pro své portály. Např.: https://example.com",
          "ERROR": "Zadejte platnou URL domény"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Odkaz na domovskou stránku",
          "PLACEHOLDER": "Odkaz na domovskou stránku portálu",
          "HELP_TEXT": "Odkaz použitý k návratu z portálu na domovskou stránku. Např.: https://example.com",
          "ERROR": "Zadejte platnou URL domovské stránky"
        },
        "THEME_COLOR": {
          "LABEL": "Barva motivu portálu",
          "HELP_TEXT": "Tato barva se zobrazí jako barva motivu portálu."
        },
        "PAGE_TITLE": {
          "LABEL": "Název stránky",
          "PLACEHOLDER": "Název stránky portálu",
          "HELP_TEXT": "Název stránky bude použit ve veřejně přístupném portálu.",
          "ERROR": "Název stránky je povinný"
        },
        "HEADER_TEXT": {
          "LABEL": "Text záhlaví",
          "PLACEHOLDER": "Text záhlaví portálu",
          "HELP_TEXT": "Text záhlaví portálu bude použit ve veřejně přístupném portálu.",
          "ERROR": "Text záhlaví portálu je povinný"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "Portál byl úspěšně vytvořen.",
          "ERROR_MESSAGE_FOR_BASIC": "Nelze vytvořit portál. Zkuste to znovu.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "Portál byl úspěšně aktualizován.",
          "ERROR_MESSAGE_FOR_UPDATE": "Nelze aktualizovat portál. Zkuste to znovu."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "Přidat nový jazyk",
        "SUB_TITLE": "Tím přidáte nový jazyk do vašeho seznamu dostupných překladů.",
        "PORTAL": "Portál",
        "LOCALE": {
          "LABEL": "Jazyk",
          "PLACEHOLDER": "Vyberte jazyk",
          "ERROR": "Jazyk je povinný"
        },
        "BUTTONS": {
          "CREATE": "Vytvořit jazyk",
          "CANCEL": "Zrušit"
        },
        "API": {
          "SUCCESS_MESSAGE": "Jazyk byl úspěšně přidán",
          "ERROR_MESSAGE": "Nelze přidat jazyk. Zkuste to znovu."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Výchozí jazyk byl úspěšně aktualizován",
          "ERROR_MESSAGE": "Nelze aktualizovat výchozí jazyk. Zkuste to znovu."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Jazyk byl úspěšně odebrán z portálu",
          "ERROR_MESSAGE": "Nelze odebrat jazyk z portálu. Zkuste to znovu."
        }
      }
    },
    "TABLE": {
      "LOADING_MESSAGE": "Načítání článků...",
      "404": "Žádné články neodpovídají vašemu hledání 🔍",
      "NO_ARTICLES": "Nejsou dostupné žádné články",
      "HEADERS": {
        "TITLE": "Název",
        "CATEGORY": "Kategorie",
        "READ_COUNT": "Zobrazení",
        "STATUS": "Stav",
        "LAST_EDITED": "Naposledy upraveno"
      },
      "COLUMNS": {
        "BY": "od",
        "AUTHOR_NOT_AVAILABLE": "Autor není k dispozici"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "Načítání článku...",
      "TITLE_PLACEHOLDER": "Název článku sem",
      "CONTENT_PLACEHOLDER": "Napište svůj článek zde",
      "API": {
        "ERROR": "Chyba při ukládání článku"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "Chyba při publikování článku",
        "SUCCESS": "Článek byl úspěšně publikován"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "Chyba při archivaci článku",
        "SUCCESS": "Článek byl úspěšně archivován"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "Chyba při vytváření konceptu článku",
        "SUCCESS": "Koncept článku byl úspěšně vytvořen"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "Potvrdit odstranění",
          "MESSAGE": "Opravdu chcete smazat tento článek?",
          "YES": "Ano, odstranit",
          "NO": "Ne, zachovat"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Článek byl úspěšně smazán",
        "ERROR_MESSAGE": "Chyba při mazání článku"
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "Přidejte prosím nadpis a obsah článku, teprve poté můžete aktualizovat nastavení"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "Hledat články"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "Vytvořit kategorii",
        "SUB_TITLE": "Kategorie bude použita ve veřejně přístupném portálu pro kategorizaci článků.",
        "PORTAL": "Portál",
        "LOCALE": "Jazyk",
        "NAME": {
          "LABEL": "Název",
          "PLACEHOLDER": "Název kategorie",
          "HELP_TEXT": "Název kategorie a ikona budou použity v veřejně přístupném portálu ke kategorizaci článků.",
          "ERROR": "Název je povinný"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug kategorie pro URL",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug je povinný"
        },
        "DESCRIPTION": {
          "LABEL": "Popis",
          "PLACEHOLDER": "Zadejte krátký popis kategorie.",
          "ERROR": "Popis je povinný"
        },
        "BUTTONS": {
          "CREATE": "Vytvořit kategorii",
          "CANCEL": "Zrušit"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kategorie byla úspěšně vytvořena",
          "ERROR_MESSAGE": "Nelze vytvořit kategorii"
        }
      },
      "EDIT": {
        "TITLE": "Upravit kategorii",
        "SUB_TITLE": "Úprava kategorie aktualizuje kategorii ve veřejně přístupném portálu.",
        "PORTAL": "Portál",
        "LOCALE": "Jazyk",
        "NAME": {
          "LABEL": "Název",
          "PLACEHOLDER": "Název kategorie",
          "HELP_TEXT": "Název kategorie a ikona budou použity v veřejně přístupném portálu ke kategorizaci článků.",
          "ERROR": "Název je povinný"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug kategorie pro URL",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug je povinný"
        },
        "DESCRIPTION": {
          "LABEL": "Popis",
          "PLACEHOLDER": "Zadejte krátký popis kategorie.",
          "ERROR": "Popis je povinný"
        },
        "BUTTONS": {
          "CREATE": "Aktualizovat kategorii",
          "CANCEL": "Zrušit"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kategorie byla úspěšně aktualizována",
          "ERROR_MESSAGE": "Nelze aktualizovat kategorii"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "Kategorie byla úspěšně smazána",
          "ERROR_MESSAGE": "Nelze smazat kategorii"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "Hledat články",
      "PLACEHOLDER": "Hledat články",
      "NO_RESULT": "Nebyly nalezeny žádné články",
      "SEARCHING": "Vyhledávání...",
      "SEARCH_BUTTON": "Hledat",
      "INSERT_ARTICLE": "Vložit odkaz",
      "IFRAME_ERROR": "URL je prázdná nebo neplatná. Nelze zobrazit obsah.",
      "OPEN_ARTICLE_SEARCH": "Vložit článek z centra nápovědy",
      "SUCCESS_ARTICLE_INSERTED": "Článek byl úspěšně vložen",
      "PREVIEW_LINK": "Náhled článku",
      "CANCEL": "Zavřít",
      "BACK": "Zpět",
      "BACK_RESULTS": "Zpět na výsledky"
    },
    "UPGRADE_PAGE": {
      "TITLE": "Centrum nápovědy",
      "DESCRIPTION": "Vytvořte uživatelsky přívětivé samoobslužné portály. Pomáhejte svým uživatelům přistupovat k článkům a získávat podporu 24/7. Upgradujte své předplatné, abyste tuto funkci povolili.",
      "SELF_HOSTED_DESCRIPTION": "Vytvořte uživatelsky přívětivé samoobslužné portály. Pomáhejte svým uživatelům přistupovat k článkům a získávat podporu 24/7. Kontaktujte prosím svého administrátora o povolení této funkce.",
      "BUTTON": {
        "LEARN_MORE": "Zjistit více",
        "UPGRADE": "Upgradujte"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "Více portálů",
          "DESCRIPTION": "Vytvořte více portálů centra nápovědy pro různé produkty pomocí stejného účtu."
        },
        "LOCALES": {
          "TITLE": "Plná podpora jazyků",
          "DESCRIPTION": "Lokalizujte portál ve vašem jazyce. Podporujeme všechny jazyky a umožňujeme překlady pro každý článek."
        },
        "SEO": {
          "TITLE": "Design přátelský k SEO",
          "DESCRIPTION": "Přizpůsobte své meta tagy pro zlepšení viditelnosti ve vyhledávačích pomocí našich stránek přátelských k SEO."
        },
        "API": {
          "TITLE": "Plná podpora API",
          "DESCRIPTION": "Použijte portál jako bezhlavé CMS s frontendovými frameworky třetích stran pomocí našich API."
        }
      }
    },
    "LOADING": "Načítání...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count} zobrazení",
          "DROPDOWN_MENU": {
            "PUBLISH": "Publikovat",
            "DRAFT": "Koncept",
            "ARCHIVE": "Archivovat",
            "DELETE": "Vymazat"
          },
          "STATUS": {
            "DRAFT": "Koncept",
            "PUBLISHED": "Publikované",
            "ARCHIVED": "Archivované"
          },
          "CATEGORY": {
            "UNCATEGORISED": "Nekategorizováno"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "Všechny články",
          "MINE": "Moje",
          "DRAFT": "Koncept",
          "PUBLISHED": "Publikované",
          "ARCHIVED": "Archivované"
        },
        "CATEGORY": {
          "ALL": "Všechny kategorie"
        },
        "LOCALE": {
          "ALL": "Všechny jazyky"
        },
        "NEW_ARTICLE": "Nový článek"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "Napsat článek",
          "SUBTITLE": "Napište bohatý článek, začněme!",
          "BUTTON_LABEL": "Nový článek"
        },
        "MINE": {
          "TITLE": "Zatím jste zde nenapsali žádné články",
          "SUBTITLE": "Všechny články, které jste napsali, se zde zobrazí pro rychlý přístup."
        },
        "DRAFT": {
          "TITLE": "V konceptech nejsou žádné články",
          "SUBTITLE": "Koncepty článků se zobrazí zde"
        },
        "PUBLISHED": {
          "TITLE": "Nejsou zde žádné publikované články",
          "SUBTITLE": "Publikované články se zobrazí zde"
        },
        "ARCHIVED": {
          "TITLE": "V archivu nejsou žádné články",
          "SUBTITLE": "Archivované články se na portálu nezobrazují, můžete je použít k označení zastaralých nebo neaktuálních stránek"
        },
        "CATEGORY": {
          "TITLE": "V této kategorii nejsou žádné články",
          "SUBTITLE": "Články v této kategorii se zobrazí zde"
        }
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "Nová kategorie",
        "EDIT_CATEGORY": "Upravit kategorii",
        "CATEGORIES_COUNT": "{n} kategorií",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "Kategorie ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount} článků)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "Nebyly nalezeny žádné kategorie",
        "SUBTITLE": "Kategorie se zobrazí zde. Kategorii můžete přidat kliknutím na tlačítko 'Nová kategorie'."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count} článků",
        "EXPAND": "Zobrazit podkategorie",
        "COLLAPSE": "Skrýt podkategorie",
        "MENU": {
          "NEW_ARTICLE": "Nový článek",
          "ADD_SUBCATEGORY": "Přidat podkategorii",
          "EDIT": "Upravit",
          "DELETE": "Smazat"
        }
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Kategorie byla úspěšně vytvořena",
            "ERROR_MESSAGE": "Nelze vytvořit kategorii"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Kategorie byla úspěšně aktualizována",
            "ERROR_MESSAGE": "Nelze aktualizovat kategorii"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "Kategorie byla úspěšně smazána",
            "ERROR_MESSAGE": "Nelze smazat kategorii"
          },
          "CONFIRM": {
            "TITLE": "Smazat kategorii",
            "DESCRIPTION": "Opravdu chcete smazat tuto kategorii? Její články zůstanou bez kategorie.",
            "DESCRIPTION_WITH_CHILDREN": "Opravdu chcete smazat tuto kategorii? Její články zůstanou bez kategorie a její {count} podkategorie budou přesunuty na nejvyšší úroveň.",
            "CONFIRM": "Smazat"
          }
        },
        "HEADER": {
          "CREATE": "Vytvořit kategorii",
          "EDIT": "Upravit kategorii",
          "DESCRIPTION": "Úprava kategorie aktualizuje kategorii ve veřejně přístupném portálu.",
          "PORTAL": "Portál",
          "LOCALE": "Jazyk"
        },
        "FORM": {
          "NAME": {
            "LABEL": "Název",
            "PLACEHOLDER": "Název kategorie",
            "ERROR": "Název je povinný"
          },
          "SLUG": {
            "LABEL": "Slug",
            "PLACEHOLDER": "Slug kategorie pro URL",
            "ERROR": "Slug je povinný",
            "HELP_TEXT": "chat.jarabot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "Popis",
            "PLACEHOLDER": "Zadejte krátký popis kategorie.",
            "ERROR": "Popis je povinný"
          },
          "PARENT_CATEGORY": {
            "LABEL": "Nadřazená kategorie",
            "PLACEHOLDER": "Vyberte nadřazenou kategorii",
            "NONE": "Žádná (nejvyšší úroveň)"
          }
        },
        "BUTTONS": {
          "CREATE": "Vytvořit",
          "EDIT": "Aktualizovat",
          "CANCEL": "Zrušit"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "{n} jazyků",
      "NEW_LOCALE_BUTTON_TEXT": "Nový jazyk",
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count} článků",
        "CATEGORIES_COUNT": "{count} kategorií",
        "DEFAULT": "Výchozí",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "Nastavit jako výchozí",
          "DELETE": "Vymazat"
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "Přidat nový jazyk",
        "DESCRIPTION": "Vyberte jazyk, ve kterém bude tento článek napsán. Ten bude přidán do vašeho seznamu překladů a později můžete přidat další.",
        "COMBOBOX": {
          "PLACEHOLDER": "Vybrat jazyk..."
        },
        "API": {
          "SUCCESS_MESSAGE": "Jazyk byl úspěšně přidán",
          "ERROR_MESSAGE": "Nelze přidat jazyk. Zkuste to znovu."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "Ukládání...",
          "SAVED": "Uloženo"
        },
        "PREVIEW": "Náhled",
        "PUBLISH": "Publikovat",
        "DRAFT": "Koncept",
        "ARCHIVE": "Archivovat",
        "BACK_TO_ARTICLES": "Zpět na články"
      },
      "DRAFT": {
        "PENDING_LABEL": "Nepublikované změny",
        "PROMOTE": "Publikovat změny",
        "DISCARD": "Zahodit změny",
        "PROMOTE_SUCCESS": "Změny konceptu byly publikovány do živého článku",
        "PROMOTE_ERROR": "Změny konceptu se nepodařilo publikovat",
        "DISCARD_SUCCESS": "Změny konceptu byly zahozeny",
        "DISCARD_ERROR": "Změny konceptu se nepodařilo zahodit"
      },
      "VERSION_HISTORY": {
        "MENU_ITEM": "Historie verzí",
        "TITLE": "Historie verzí",
        "BACK": "Zpět na článek",
        "LOADING": "Načítání verzí...",
        "EMPTY": "Zatím žádné verze. Úpravy tohoto článku se zde zobrazí.",
        "EMPTY_CONTENT": "Tato verze neobsahuje žádný obsah.",
        "CURRENT_BADGE": "Aktuální",
        "RESTORED_BADGE": "Obnoveno",
        "AUTOMATED_USER": "Automatická aktualizace",
        "RESTORE": "Obnovit tuto verzi",
        "RESTORE_DIALOG": {
          "TITLE": "Obnovit tuto verzi?",
          "DESCRIPTION": "Článek se vrátí ke znění této verze. Nic se neztratí — aktuální text zůstane v historii a publikovaný článek bude nadále zobrazovat živou verzi, dokud změnu nepublikujete.",
          "CONFIRM": "Obnovit"
        },
        "RESTORE_SUCCESS": "Verze byla obnovena",
        "RESTORE_ERROR": "Tuto verzi se nepodařilo obnovit",
        "FETCH_ERROR": "Nepodařilo se načíst historii verzí"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "Další vlastnosti",
        "TRANSLATE": "Přeložit",
        "SOURCE": "Markdown",
        "UNCATEGORIZED": "Nekategorizováno",
        "EDITOR_PLACEHOLDER": "Napište něco...",
        "HTML_EMBED": {
          "TITLE": "Vložit vlastní HTML",
          "DESCRIPTION": "Vložte čistý HTML kód, například iframe, embed nebo widget. Na publikovaném článku se vykreslí tak, jak je.",
          "PLACEHOLDER": "<iframe src=\"https://...\"></iframe>",
          "INSERT": "Vložit"
        },
        "PRIMARY_CATEGORY": "Hlavní kategorie"
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "Vlastnosti článku",
        "SLUG": "Slug",
        "EDIT_SLUG": "Upravit slug",
        "META_DESCRIPTION": "Meta popis",
        "META_DESCRIPTION_PLACEHOLDER": "Přidat meta popis",
        "META_TITLE": "Meta titulek",
        "META_TITLE_PLACEHOLDER": "Přidat meta titulek",
        "META_TAGS": "Meta tagy",
        "META_TAGS_PLACEHOLDER": "Přidat meta tagy",
        "SET_AS_HOMEPAGE": "Nastavit jako domovskou stránku",
        "SET_AS_HOMEPAGE_HELP": "Zobrazit tento článek jako domovskou stránku centra nápovědy pro tento jazyk. Přidejte {'{{NAV}}'} do obsahu pro zobrazení vyhledávání a kategorií.",
        "LANGUAGE_MUTATIONS": "Jazykové mutace",
        "LANGUAGE_MUTATIONS_EMPTY": "Žádné propojené články",
        "ADD_MUTATION": "Přidat",
        "REMOVE_MUTATION": "Odebrat"
      },
      "LANGUAGE_MUTATIONS_DIALOG": {
        "TITLE": "Propojit jazykové mutace",
        "SEARCH_PLACEHOLDER": "Hledat články podle názvu",
        "EMPTY": "Žádné odpovídající články",
        "CANCEL": "Zrušit",
        "ADD_SELECTED": "Přidat vybrané",
        "SUCCESS": "Mutace aktualizovány",
        "ERROR": "Nepodařilo se aktualizovat mutace"
      },
      "TRANSLATE_DIALOG": {
        "TITLE": "Přeložit článek",
        "DESCRIPTION": "Vyberte jazyky, do kterých chcete tento článek přeložit. Jazyky, které jsou již přeložené, budou znovu přeloženy do konceptu ke kontrole.",
        "EMPTY": "Nejsou k dispozici žádné další jazyky.",
        "CONNECTED_BADGE": "Přeloženo",
        "CANCEL": "Zrušit",
        "TRANSLATE": "Přeložit",
        "SUCCESS": "Překlad začne brzy. Přeložené články se brzy zobrazí jako jazykové mutace.",
        "ERROR": "Nepodařilo se spustit překlad"
      },
      "SLUG_DIALOG": {
        "TITLE": "Upravit URL článku",
        "DESCRIPTION": "Změňte popisnou část slugu tohoto článku. Staré odkazy budou nadále fungovat — automaticky přesměrují sem.",
        "INPUT_LABEL": "Slug",
        "PLACEHOLDER": "getting-started",
        "PREFIX_HINT": "Číselná předpona je trvalý identifikátor a nelze ji změnit.",
        "PREVIEW": "URL článku",
        "CANCEL": "Zrušit",
        "SAVE": "Uložit",
        "SUCCESS": "URL článku aktualizována",
        "ERROR": "Nepodařilo se aktualizovat URL článku"
      },
      "API": {
        "ERROR": "Chyba při ukládání článku"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "Nový portál",
      "PORTALS": "Portály",
      "CREATE_PORTAL": "Vytvářejte a spravujte více portálů",
      "ARTICLES": "články",
      "DOMAIN": "doména",
      "PORTAL_NAME": "Název portálu"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "Vytvořit nový portál",
      "DESCRIPTION": "Pojmenujte svůj portál a vytvořte uživatelsky přívětivý URL slug. Obojí můžete později upravit v nastavení.",
      "CONFIRM_BUTTON_LABEL": "Vytvořit",
      "NAME": {
        "LABEL": "Název",
        "PLACEHOLDER": "Uživatelská příručka | JARABOT",
        "MESSAGE": "Zvolte název pro váš portál.",
        "ERROR": "Název je povinný"
      },
      "SLUG": {
        "LABEL": "Slug",
        "PLACEHOLDER": "uzivatelska-prirucka",
        "ERROR": "Slug je povinný",
        "FORMAT_ERROR": "Použijte pouze písmena, číslice a pomlčky, například: user-guide"
      }
    },
    "DICTIONARY_PAGE": {
      "HEADER": {
        "TITLE": "Překladový slovník",
        "DESCRIPTION": "Pojmy definované zde se přidají do promptu pro AI překlad, aby se vždy překládaly stejně. Klíčový pojem je napsán v jazyce {locale}."
      },
      "NEW_TERM": "Nový pojem",
      "EMPTY_STATE": {
        "TITLE": "Zatím žádné pojmy ve slovníku",
        "SUBTITLE": "Přidejte pojem a jeho překlad pro každý jazyk. Při překladu článku se tyto pojmy vynutí, aby terminologie vašeho produktu zůstala konzistentní."
      },
      "LIST": {
        "TERM": "Pojem",
        "TRANSLATIONS": "Překlady",
        "ACTIONS": "Akce"
      },
      "DICTIONARY_DIALOG": {
        "HEADER": {
          "CREATE": "Přidat pojem",
          "EDIT": "Upravit pojem",
          "DESCRIPTION": "Pojem níže se vynutí během AI překladu článků centra nápovědy.",
          "PORTAL": "Portál",
          "PRIMARY_LANGUAGE": "Hlavní jazyk"
        },
        "FORM": {
          "TERM": {
            "LABEL": "Pojem ({locale})",
            "PLACEHOLDER": "Inbox",
            "ERROR": "Pojem je povinný"
          },
          "DESCRIPTION": {
            "LABEL": "Kontext / poznámky (volitelné)",
            "PLACEHOLDER": "Kdy a jak se tento pojem používá, aby se překladatel lépe zorientoval."
          },
          "TRANSLATIONS": "Překlady",
          "TRANSLATION_PLACEHOLDER": "Nechte prázdné, pokud má AI překládat volně",
          "AUTO_TRANSLATE": {
            "BUTTON": "Přeložit vše",
            "CONFIRM": "Přeložit do {count} jazyků pomocí AI?",
            "CONFIRM_BUTTON": "Přeložit",
            "CANCEL": "Zrušit",
            "SUCCESS": "Překlady vygenerovány — zkontrolujte a uložte",
            "ERROR": "Automatický překlad selhal, zkuste to znovu"
          }
        },
        "BUTTONS": {
          "CREATE": "Přidat pojem",
          "EDIT": "Uložit",
          "CANCEL": "Zrušit"
        },
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Pojem byl úspěšně přidán",
            "ERROR_MESSAGE": "Pojem se nepodařilo přidat, zkuste to znovu"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Pojem byl úspěšně aktualizován",
            "ERROR_MESSAGE": "Pojem se nepodařilo aktualizovat, zkuste to znovu"
          }
        }
      },
      "DELETE": {
        "CONFIRM": {
          "TITLE": "Odstranit pojem",
          "DESCRIPTION": "Opravdu chcete odstranit tento pojem? Během překladu se již nebude vynucovat.",
          "CONFIRM": "Odstranit"
        },
        "API": {
          "SUCCESS_MESSAGE": "Pojem byl úspěšně odstraněn",
          "ERROR_MESSAGE": "Pojem se nepodařilo odstranit, zkuste to znovu"
        }
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "Logo",
          "IMAGE_UPLOAD_ERROR": "Nelze nahrát obrázek! Zkuste to znovu",
          "IMAGE_UPLOAD_SUCCESS": "Obrázek byl úspěšně přidán. Klikněte prosím na Uložit změny pro uložení loga",
          "IMAGE_DELETE_SUCCESS": "Logo úspěšně smazáno",
          "IMAGE_DELETE_ERROR": "Nelze smazat logo",
          "IMAGE_UPLOAD_SIZE_ERROR": "Velikost obrázku by měla být menší než {size} MB"
        },
        "HERO_IMAGE": {
          "LABEL": "Obrázek na pozadí",
          "HELP_TEXT": "Volitelný obrázek na celou šířku zobrazený za vycentrovaným vyhledávacím polem na domovské stránce centra nápovědy.",
          "IMAGE_UPLOAD_ERROR": "Nelze nahrát obrázek! Zkuste to znovu",
          "IMAGE_UPLOAD_SUCCESS": "Obrázek byl úspěšně přidán. Klikněte prosím na Uložit změny pro uložení obrázku na pozadí",
          "IMAGE_DELETE_SUCCESS": "Obrázek na pozadí úspěšně smazán",
          "IMAGE_DELETE_ERROR": "Nelze smazat obrázek na pozadí",
          "IMAGE_UPLOAD_SIZE_ERROR": "Velikost obrázku by měla být menší než {size} MB"
        },
        "HOMEPAGE_ARTICLES": {
          "LABEL": "Články domovské stránky",
          "EMPTY": "Žádný článek není nastaven jako domovská stránka. Nastavte jej ve vlastnostech článku.",
          "HELP_TEXT": "Článek zobrazený jako domovská stránka pro každý jazyk. Kliknutím jej otevřete, nebo odeberte pro obnovení výchozí domovské stránky.",
          "REMOVE": "Odebrat",
          "REMOVE_SUCCESS": "Článek domovské stránky odebrán",
          "REMOVE_ERROR": "Nelze odebrat článek domovské stránky"
        },
        "NAME": {
          "LABEL": "Název",
          "PLACEHOLDER": "Název portálu",
          "ERROR": "Název je povinný"
        },
        "HEADER_TEXT": {
          "LABEL": "Text záhlaví",
          "PLACEHOLDER": "Text záhlaví portálu"
        },
        "PAGE_TITLE": {
          "LABEL": "Název stránky",
          "PLACEHOLDER": "Název stránky portálu"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Odkaz na domovskou stránku",
          "PLACEHOLDER": "Odkaz na domovskou stránku portálu",
          "ERROR": "Neplatná URL. Odkaz na domovskou stránku musí začínat 'http://' nebo 'https://'."
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug portálu"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "Widget živého chatu",
          "PLACEHOLDER": "Vyberte widget živého chatu",
          "HELP_TEXT": "Vyberte widget živého chatu, který se zobrazí ve vašem centru nápovědy"
        },
        "PUBLIC_ACCESS": {
          "LABEL": "Veřejně dostupné",
          "HELP_TEXT": "Pokud je nastaveno jako veřejné, portál může zobrazit kdokoli s odkazem na portál",
          "OPTIONS": {
            "PUBLIC": "Ano",
            "PRIVATE": "Ne"
          }
        },
        "LINK_TARGET": {
          "LABEL": "Cíl odkazů",
          "HELP_TEXT": "Vyberte, zda se odkazy v článcích otevírají v aktuálním okně, nebo v novém.",
          "OPTIONS": {
            "CURRENT_WINDOW": "Aktuální okno",
            "NEW_WINDOW": "Nové okno"
          }
        },
        "DEFAULT_IMAGE_SIZE": {
          "LABEL": "Výchozí velikost obrázku",
          "HELP_TEXT": "Velikost, která se použije u každého obrázku vloženého do článku. Zvolte Originál, pokud se mají obrázky vkládat v původní velikosti a chcete velikost volit u každého zvlášť."
        },
        "BRAND_COLOR": {
          "LABEL": "Barva značky"
        },
        "CUSTOM_HTML": {
          "LABEL": "Vlastní HTML",
          "PLACEHOLDER": "<!-- Sem vložte svůj analytický nebo měřicí kód -->",
          "HELP_TEXT": "Vloží se na začátek značky <body> na každé stránce centra nápovědy. Použijte jej pro Google Analytics, Google Tag Manager nebo jakýkoli jiný měřicí kód. Kód se vykreslí přesně tak, jak jej zadáte, a nijak se nekontroluje."
        },
        "SAVE_CHANGES": "Uložit změny"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "Vlastní doména",
          "LABEL": "Vlastní doména:",
          "DESCRIPTION": "Svůj portál můžete hostovat na vlastní doméně. Pokud je například váš web vase-domena.com a chcete, aby byl váš portál dostupný na docs.vase-domena.com, jednoduše to zadejte do tohoto pole.",
          "PLACEHOLDER": "Vlastní doména portálu",
          "EDIT_BUTTON": "Upravit vlastní doménu",
          "ADD_BUTTON": "Přidat vlastní doménu",
          "DIALOG": {
            "ADD_HEADER": "Přidat vlastní doménu",
            "EDIT_HEADER": "Upravit vlastní doménu",
            "ADD_CONFIRM_BUTTON_LABEL": "Přidat doménu",
            "EDIT_CONFIRM_BUTTON_LABEL": "Aktualizovat doménu",
            "LABEL": "Vlastní doména",
            "PLACEHOLDER": "Vlastní doména portálu",
            "ERROR": "Vlastní doména je povinná"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "Konfigurace DNS",
            "DESCRIPTION": "Přihlaste se k účtu u svého poskytovatele DNS a přidejte záznam CNAME pro subdoménu směřující na chat.jarabot.com",
            "HELP_TEXT": "Jakmile to bude hotové, můžete kontaktovat naši podporu a požádat o automaticky generovaný SSL certifikát.",
            "CONFIRM_BUTTON_LABEL": "Rozumím!"
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "Smazat {portalName}",
          "HEADER": "Smazat portál",
          "DESCRIPTION": "Trvale smazat tento portál. Tato akce je nevratná",
          "DIALOG": {
            "HEADER": "Opravdu chcete smazat {portalName}?",
            "DESCRIPTION": "Toto je trvalá akce, kterou nelze vrátit zpět.",
            "CONFIRM_BUTTON_LABEL": "Vymazat"
          }
        },
        "EDIT_CONFIGURATION": "Upravit konfiguraci"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portál byl úspěšně vytvořen",
          "ERROR_MESSAGE": "Nelze vytvořit portál"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portál byl úspěšně aktualizován",
          "ERROR_MESSAGE": "Nelze aktualizovat portál"
        }
      }
    },
    "ATTACHMENTS": {
      "TITLE": "Přílohy",
      "DRAFT_BADGE": "Koncept",
      "ADD_BUTTON": "Přidat soubor",
      "DROP_HERE": "Přetáhněte soubory sem",
      "COPY_LINK": "Kopírovat odkaz",
      "LINK_COPIED": "Odkaz zkopírován do schránky",
      "COPY_FAILED": "Nepodařilo se zkopírovat odkaz",
      "DELETE": "Smazat",
      "CANCEL": "Zrušit",
      "QUEUED": "Ve frontě",
      "UPLOADING": "Nahrává se",
      "UPLOAD_FAILED": "Nahrávání souboru selhalo",
      "FILE_TOO_LARGE": "Soubor překračuje limit 40 MB"
    }
  }
}
